import { SAVE_SHOW_MEMBERS_ON_MAP } from "./actions.type";

import { SET_SHOW_MEMBERS_ON_MAP } from "./mutations.type";

const STATE = {
  showMembersOnMap: {
    type: Object,
  },
};

const GETTERS = {
  showMembersOnMap: (state) => state.showMembersOnMap,
};

const ACTIONS = {
  [SAVE_SHOW_MEMBERS_ON_MAP](context, params) {
    context.commit(SET_SHOW_MEMBERS_ON_MAP, params);
  },
};

const MUTATIONS = {
  [SET_SHOW_MEMBERS_ON_MAP](state, data) {
    state.showMembersOnMap = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  getters: GETTERS,
  mutations: MUTATIONS,
  actions: ACTIONS,
};
